export default __webpack_public_path__ + "static/media/Gruppe.2c2115bc.JPG";